import { render, staticRenderFns } from "./CreateEvent.vue?vue&type=template&id=3d2b04c1&"
import script from "./CreateEvent.vue?vue&type=script&lang=ts&"
export * from "./CreateEvent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "CreateEvent.vue"
export default component.exports